import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import type { ReactNode } from 'react';

const TRIGGER =
  'grid size-[18px] shrink-0 place-items-center rounded-full border border-hairline text-[11px] font-bold leading-none text-muted transition hover:border-royal/45 hover:text-royal data-open:border-royal/45 data-open:text-royal dark:border-dark-line';

const PANEL =
  'z-50 w-[min(340px,calc(100vw-1.5rem))] overflow-y-auto rounded-panel border border-hairline bg-white p-3.5 shadow-menu [--anchor-gap:6px] [--anchor-max-height:26rem] [--anchor-padding:12px] dark:border-dark-line dark:bg-dark-panel';

export function HelpHint({
  title,
  children,
}: {
  readonly title: string;
  readonly children: ReactNode;
}): ReactNode {
  return (
    <Popover className="contents">
      <PopoverButton className={TRIGGER} aria-label={`What does “${title}” mean?`}>
        ?
      </PopoverButton>

      <PopoverPanel anchor="bottom start" className={PANEL}>
        <p className="mb-2 text-[13px] font-bold text-navy dark:text-dark-ink">{title}</p>
        <div className="flex flex-col gap-2 text-[12.5px] leading-relaxed text-muted">
          {children}
        </div>
      </PopoverPanel>
    </Popover>
  );
}
